import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OrderCreationService } from '../../../../Services/order-creation.service';
import { NotificationService } from '../../../../Services/notification.service';
import { FirmSelectionService } from '../../../../Services/firm-selection.service';
import { HttpParams } from '@angular/common/http';
import { AuthService } from '../../../../Services/auth.service';

@Component({
  selector: 'app-kalakar-account',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './kalakar-account.component.html',
  styleUrl: './kalakar-account.component.css'
})
export class KalakarAccountComponent implements OnInit {
  isLoading = true;
  summary: any = {
    totalOrders: 0,
    totalPaid: 0,
    totalUnpaid: 0,
    totalLabourCharges: 0,
    paidLabourCharges: 0,
    unpaidLabourCharges: 0,
  };

  constructor(
    private orderservice: OrderCreationService,
    private firmSelectionService: FirmSelectionService,
    private notificationService: NotificationService,
    private authService:AuthService
  ) {}

  ngOnInit() {
    // const supplierId = localStorage.getItem('supplierId');
    const supplierId = this.authService.getUserId();
    if (!supplierId) {
      this.notificationService.showError('Supplier ID not found', 'Error');
      this.isLoading = false;
      return;
    }

    const currentFirm = this.firmSelectionService.getselectedFirmName();
    if (currentFirm) {
      this.fetchSummary(supplierId, currentFirm.id);
    } else {
      this.firmSelectionService.selectedFirmName$.subscribe(firm => {
        if (firm) this.fetchSummary(supplierId, firm.id);
      });
    }
  }

  fetchSummary(supplierId: string, firmId: number) {
    this.isLoading = true;
    const params = new HttpParams()
      .set('supplier_id', supplierId);

    this.orderservice.getOrders(params).subscribe({
      next: (res: any) => this.calculateSummary(res.data.filter((order: any) => order.handover_status === 'handed_over')),
      error: () => {
        this.notificationService.showError('Failed to load payment summary', 'Error');
        this.isLoading = false;
      },
      complete: () => (this.isLoading = false)
    });
  }

  calculateSummary(data: any[]) {
    let totalLabour = 0;
    let paidLabour = 0;
    let unpaidLabour = 0;

    data.forEach(o => {
      const paid = +o.ordc_last_payment || 0;
      const total = +(o.ordc_labour_charges/o.quantity)*o.approved_quantity || 0;

      totalLabour += total;
      paidLabour += paid;
      unpaidLabour += total - paid;
    });

    const paidOrders = data.filter(o => o.ordc_payment_status === 'Paid');
    const unpaidOrders = data.filter(o => o.ordc_payment_status === 'Unpaid');

    this.summary = {
      totalOrders: data.length,
      totalPaid: paidOrders.length,
      totalUnpaid: unpaidOrders.length,
      totalLabourCharges: totalLabour,
      paidLabourCharges: paidLabour,
      unpaidLabourCharges: unpaidLabour,
    };
  }
}
